import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import * as debtRegister from '@debbie/common/dist/debt-register/index.js';
import { isDocumentFoundation, DocumentTypes, } from '@debbie/common/dist/documents/index.js';
import { PaymentPlanStatus, getCurrentPaymentPlan, } from '@debbie/common/dist/economy/payment-plans/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import * as documentsAPI from '@debbie/cortex/dist/api/documents.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { File, CopyToClipboard, Loading, Badge, Modal, Button, Table, MoneyInput, Select, Checkbox, DateInput, } from '../index.js';
import THEME from '../../theme.js';
import { Eye, Info, Shield, CheckCircle } from '../Icons/index.js';
import { usePaymentPlansByCaseId } from '@debbie/cortex/dist/paymentPlans/index.js';
import q from '@debbie/cortex/dist/query.js';
import { documentsEntity } from '@debbie/cortex/dist/documents/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import UserPreview from '../performed-by/UserPreview.js';
const DocumentsTableRow = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const creditorLoadable = useCreditor(props.case?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const customer = useSelector((s) => props.case && selectCustomerById(s, props.case.customerId));
    const paymentPlansLoadable = usePaymentPlansByCaseId(props.case?.caseId);
    const paymentPlans = h.hasData(paymentPlansLoadable)
        ? paymentPlansLoadable.data
        : null;
    const collectorLoadable = useCollector((props.case &&
        creditor &&
        getCollectorOnCase(props.case.type, props.case.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId)) ||
        undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const { document } = props;
    const paymentPlan = getCurrentPaymentPlan(paymentPlans);
    const docId = `D${document.id}`;
    const [documentSignLink, setDocumentSigningLink] = useState(null);
    const [loadingSigningLink, setLoadingSigningLink] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [documentType, setdocumentType] = useState(document.type);
    const [documentAmount, setdocumentAmount] = useState(document.meta.amount);
    const [documentDate, setDocumentDate] = useState(document.date);
    const [documentSignedAt, setDocumentSignedAt] = useState(document.signedAt || null);
    const [isVisibleForDebtor, setIsVisibleForDebtor] = useState(document.minAccessRole === 'debtor');
    const file = document.signedFile || document.file;
    const updateDocument = async () => {
        const hasCreatedOrActivePaymentPlan = paymentPlan
            ? [PaymentPlanStatus.CREATED, PaymentPlanStatus.ACTIVE].includes(paymentPlan.status)
            : false;
        const autoRKIEnabled = debtRegister.isAutoRKIEnabled(tenant, creditor);
        const autoRKIOpenEnabled = debtRegister.isAutoRKIOpenEnabled(tenant, creditor);
        const autoMoveToOpenRKI = customer &&
            debtRegister.canMoveToOpen(customer.users, {
                signedAt: document.signedAt,
                date: document.date,
                type: documentType,
                refIdType: document.refIdType,
                meta: {
                    ...document.meta,
                    amount: documentAmount ? documentAmount : undefined,
                },
            });
        if (autoRKIEnabled &&
            autoRKIOpenEnabled &&
            autoMoveToOpenRKI &&
            !hasCreatedOrActivePaymentPlan) {
            if (confirm(lang.documents.autoRKIUpdateFoundation)) {
                await documentsAPI.update(props.document.documentId, {
                    refId: props.refId,
                    type: documentType,
                    date: documentDate,
                    signedAt: documentSignedAt || undefined,
                    minAccessRole: isVisibleForDebtor ? 'debtor' : 'caseworker',
                    meta: {
                        ...document.meta,
                        amount: documentAmount,
                    },
                });
                q.invalidate(keys.write.modify(documentsEntity, props.document.documentId));
            }
        }
        else {
            await documentsAPI.update(props.document.documentId, {
                refId: props.refId,
                type: documentType,
                date: documentDate,
                signedAt: documentSignedAt || undefined,
                minAccessRole: isVisibleForDebtor ? 'debtor' : 'caseworker',
                meta: {
                    ...document.meta,
                    amount: documentAmount,
                },
            });
            q.invalidate(keys.write.modify(documentsEntity, props.document.documentId));
        }
    };
    const mapping = props.connectMappings
        ? props.connectMappings[document.documentId]
        : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            props.selectable && (React.createElement("td", { style: {
                    width: '30px',
                    padding: '4px 10px',
                } },
                React.createElement(Checkbox, { style: { margin: '0' }, checkMark: true, checkboxStyle: { margin: '0' }, checked: props.selectableChecked, onChange: (e) => {
                        props.selectableOnChange &&
                            props.selectableOnChange(e.target.checked);
                    } }))),
            !props.hideInfo && (React.createElement("td", { style: {
                    cursor: 'pointer',
                    padding: '4px 5px 5px 10px',
                }, onClick: async () => {
                    setModalOpen(true);
                } },
                React.createElement(Info, { style: {
                        width: '13px',
                    } }))),
            React.createElement("td", { style: {
                    width: '35px',
                    padding: '4px 5px',
                } }, document.createdByUserId && (React.createElement(UserPreview, { id: document.createdByUserId }))),
            React.createElement("td", null,
                file ? (React.createElement(File, { file: file, noWrap: true, style: { maxWidth: '200px' } })) : null,
                React.createElement("p", { style: {
                        margin: '0',
                        fontSize: '0.7em',
                    } },
                    lang.documents.date,
                    ' ',
                    moment(document.date).format(THEME.DATE_FORMAT_SHORT),
                    document.signedAt &&
                        `, ${lang.documents.signedAt} ${moment(document.signedAt).format(THEME.DATE_FORMAT_SHORT)}`)),
            React.createElement("td", { style: { width: '30px', padding: '4px 5px' } },
                React.createElement(Badge, { theme: "lightgrey" }, lang.documentTypes[document.type] || document.type)),
            React.createElement("td", { style: { width: '30px', padding: '4px 5px' } }, document.signedAt && (React.createElement(CheckCircle, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.documentSigned, style: { color: '#3b92d3' } }))),
            React.createElement("td", { style: { width: '30px', padding: '4px 5px' } }, isDocumentFoundation(document) && (React.createElement(Shield, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.isFoundation, style: { color: '#3b92d3' } }))),
            React.createElement("td", { style: { width: '30px', padding: '4px 5px' } }, document.minAccessRole === 'debtor' && (React.createElement(Eye, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.visibleForDebtor, style: { color: '#3b92d3' } }))),
            React.createElement("td", { style: { width: '30px', padding: '4px 5px' } }, mapping && (
            // @ts-ignore
            React.createElement(Link, { to: `/connect/connections/${mapping.connectionId}`, "data-for": "tooltip-default", "data-tip": lang.connect.fromConnectPartner, style: { textDecoration: 'none', color: '#3b92d3' } }, "\u21CC")))),
        modalOpen && (React.createElement(Modal, { header: (file && file.fileName) || lang.documents.documents, onToggle: () => setModalOpen(!modalOpen), maxWidth: "600px" },
            React.createElement(Table, { zebra: true },
                React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.docId),
                    React.createElement("td", null,
                        React.createElement("b", null,
                            React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, docId)))),
                React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.type),
                    React.createElement("td", null,
                        React.createElement(Select, { value: documentType, style: { margin: '0' }, onChange: (e) => setdocumentType(e.target.value) }, Object.values(DocumentTypes).map((dT, key) => (React.createElement("option", { value: dT, key: key }, lang.documentTypes[dT])))))),
                React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.amount),
                    React.createElement("td", null,
                        React.createElement(MoneyInput, { value: documentAmount || null, allowNull: true, placeholder: lang.documents.amount, onChange: (c) => setdocumentAmount(c === null ? c : Math.abs(c)) }))),
                document.meta.note && (React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.note),
                    React.createElement("td", null, document.meta.note))),
                React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.visibleForDebtor),
                    React.createElement("td", null,
                        React.createElement(Checkbox, { checked: isVisibleForDebtor, onChange: (e) => setIsVisibleForDebtor(e.target.checked) }))),
                React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.file),
                    React.createElement("td", null, document.file && React.createElement(File, { file: document.file }))),
                React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.signedFile),
                    React.createElement("td", null, document.signedFile && React.createElement(File, { file: document.signedFile }))),
                React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.createdBy),
                    React.createElement("td", null, document.createdByUserId && (React.createElement(UserPreview, { id: document.createdByUserId })))),
                React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.date),
                    React.createElement("td", null,
                        React.createElement(DateInput, { placeholder: lang.documents.date, value: moment(documentDate), allowNull: false, onChange: (d) => {
                                setDocumentDate(d.toISOString());
                            } }))),
                React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.signedAt),
                    React.createElement("td", null,
                        React.createElement(DateInput, { placeholder: lang.documents.signedAt, value: documentSignedAt ? moment(documentSignedAt) : null, allowNull: true, onChange: (d) => {
                                setDocumentSignedAt(d ? d.toISOString() : null);
                            } }))),
                React.createElement("tr", null,
                    React.createElement("td", null, lang.documents.signingLink),
                    React.createElement("td", null, documentSignLink ? (React.createElement("span", { className: "ui-test-2940885f" },
                        React.createElement(CopyToClipboard, { text: documentSignLink }, "COPY LINK"))) : loadingSigningLink ? (React.createElement(Loading, { width: "16px" })) : document.signedAt ? (React.createElement(CheckCircle, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.documentSigned, style: { color: '#3b92d3' } })) : (document.file &&
                        document.file.contentType === 'application/pdf' && (React.createElement(Button, { style: { cursor: 'pointer' }, "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.generateLinkForSigning, className: "ui-test-371d44bd", onClick: async () => {
                            setLoadingSigningLink(true);
                            try {
                                const successURL = collector && collector.debtorWebBase
                                    ? collector.debtorWebBase + '/signed'
                                    : undefined;
                                if (!props.name) {
                                    throw new Error('No name provided');
                                }
                                if (!props.role) {
                                    throw new Error('No role provided');
                                }
                                const res = await documentsAPI.getLinkToSignDocument(document.documentId, props.role, props.name, successURL);
                                setDocumentSigningLink(res.link);
                            }
                            catch (error) {
                                console.error(error);
                                alert('Error. Please try again or contact support.');
                            }
                            setLoadingSigningLink(false);
                        }, size: "small", theme: "secondary" }, lang.documents.generateSigningLink)))))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(ButtonDiv, null,
                React.createElement(Button, { onClick: async () => {
                        if (confirm(`${lang.documents.sureYouWantToDelete} ${document.file ? document.file.fileName : ''}?`)) {
                            await documentsAPI.del(document.documentId);
                            q.invalidate(keys.write.modify(documentsEntity, document.documentId));
                        }
                    }, theme: "dangerous" }, lang.documents.deleteDocument),
                React.createElement(Button, { loading: submitting, onClick: async () => {
                        setSubmitting(true);
                        if (confirm(`${lang.documents.sureYouWantToSave}`)) {
                            await updateDocument();
                        }
                        setSubmitting(false);
                    } }, lang.documents.saveDocument))))));
};
export default DocumentsTableRow;
const ButtonDiv = styled.div `
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
`;
//# sourceMappingURL=DocumentsTableRow.js.map